import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SectionCardProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  iconBg?: string;
  iconColor?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({
  icon: Icon,
  title,
  subtitle,
  iconBg = "bg-indigo-50",
  iconColor = "text-indigo-600",
  action,
  children,
  className,
}: SectionCardProps) {
  return (
    <div
      className={cn(
        "bg-white p-5 rounded-2xl border border-gray-100 shadow-sm space-y-5",
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className={cn(
              "w-10 h-10 rounded-xl flex items-center justify-center",
              iconBg,
              iconColor,
            )}
          >
            <Icon size={20} />
          </div>
          <div>
            <h4 className="font-black text-[#003366] text-sm uppercase tracking-widest">{title}</h4>
            {subtitle && (
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {action && <div>{action}</div>}
      </div>
      {children}
    </div>
  );
}
